import { Container, Row, Col } from 'react-grid-system';
//import RightPanel from './RightPanel';
import useStore from '../../store/store';
import { useScreenClass } from 'react-grid-system';
const roundValue = (value) => {
	return +(Math.round(value + "e+1") + "e-1");
}

const MeasuredDbPanel = ({
	initialMeasurementDistance,
	RecieverNoiseLevel2,
	setinitialMeasurementDistance,
	setinitialSoundNoise,
	initialSoundNoise,
	receiverSPLNoBarrier,
}) => {

	const barrierScenario = useStore((state) => state.scenario); // this is the drop down.
	console.log(barrierScenario);
	if (barrierScenario === 'noBarriers') {
		RecieverNoiseLevel2 = '';
	}
	else {
		RecieverNoiseLevel2 = roundValue(RecieverNoiseLevel2);
	}
	const screenClass = useScreenClass();
	return (
		<div className="panel" id="measuredDbPanel" style={{ height: '100%' }}>
			<Container>
				<Row style={{ minWidth: `${['md', 'lg', 'xl', 'xxl'].includes(screenClass) ? '660px' : 'auto'}` }}>
					<Col xs={12} md={6} style={{ paddingLeft: '0px' }}>
						Measurement distance
						<input style={{ marginTop: '0px' }} onChange={(e) => { setinitialMeasurementDistance(e.target.value) }} type="text" className='inner-panel-boxed-input ' name="measurementDistance" value={initialMeasurementDistance} />
						m
					</Col>
					<Col xs={12} md={6} style={{ paddingLeft: '0px' }}>
						Measured sound pressure
						<input style={{ marginTop: '0px' }} onChange={(e) => { setinitialSoundNoise(e.target.value) }} type="text" className='inner-panel-boxed-input' name="soundNoise" value={initialSoundNoise} />
						dB(A)
					</Col>
				</Row>
				<Row style={{ justifyContent: 'center' }}>
					<div class="panel-bold-title">Receiver noise level</div>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '5px' }}>
						No barrier
						<div className="output" style={{ marginTop: '0px' }}>
							{roundValue(receiverSPLNoBarrier)}
						</div>
						dB(A)
					</div>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '15px' }}>
						With Barrier
						<div className="output" style={{ marginTop: '0px' }}>
							{RecieverNoiseLevel2}
						</div>
						dB(A)
					</div>
				</Row>
			</Container>
		</div>
	)
}

export default MeasuredDbPanel;